import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { PieChart } from "@mui/x-charts/PieChart";
import { getAllMerchantDashboardAnalytics } from "services/usersServices";
import { compose } from "redux";
import { withRouter } from "react-router";
import NavigationActions from "redux/navigation/actions";
import Loader from "components/Loader";

const { success, error } = NavigationActions;

const MerchantDashboard = ({ token, success, error, user }) => {
  const barColors = [
    "#FF5733",
    "#33FF57",
    "#3357FF",
    "#FFC300",
    "#DAF7A6",
    "#FF33FF",
    "#33FFF9",
    "#B6FF33",
    "#FF8633",
    "#8E44AD",
    "#C0392B"
  ];

  const [analyticsData, setAnalyticsData] = useState({
    counts: [
      {
        data: [
          { id: 0, value: 0, label: "Total" },
          { id: 1, value: 0, label: "Active" },
          { id: 2, value: 0, label: "In-Active" }
        ]
      }
    ],
    subscriptionCounts: [
      { data: [{ id: 0, value: 0, label: "", color: barColors[0] }] }
    ]
  });

  const [isLoading, setIsLoading] = useState(true);

  const getAllDashboardAnalyticsData = async () => {
    setIsLoading(true);
    try {
      const response = await getAllMerchantDashboardAnalytics(token, user?._id);

      if (response?.success) {
        const data = {
          counts: [
            {
              data: [
                {
                  id: 0,
                  value:
                    response.data.activeUsers + response.data.inactiveUsers,
                  label: "Total",
                  color: "#37B4FF"
                },
                {
                  id: 1,
                  value: response.data.activeUsers,
                  label: "Active",
                  color: "#02D6D2"
                },
                {
                  id: 2,
                  value: response.data.inactiveUsers,
                  label: "In-Active",
                  color: "#8E44AD"
                }
              ]
            }
          ],
          subscriptionCounts: [
            {
              data: response.call.map((value, index) => ({
                id: index,
                name: value.name,
                value: value.calllogcount,
                color: barColors[index]
              }))
            }
          ]
        };

        setAnalyticsData(data);
      } else {
        error(response.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user?._id && token) getAllDashboardAnalyticsData();
  }, [user?._id, token]);

  const pieData = analyticsData.subscriptionCounts[0].data.map(item => ({
    id: item.id,
    value: item.value,
    label: item.name,
    color: item.color
  }));

  return (
    <div className="container-fluid">
      <div className="row title-sec align-items-center">
        <div className="col-sm headline">Dashboard</div>
      </div>
      <div className="div-container">
        <div className="row ma-0">
          <div className="col-12 card rounded py-4">
            <h3>User Stats</h3>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <PieChart
                  series={[
                    {
                      data: analyticsData.counts[0].data.map(item => ({
                        id: item.id,
                        value: item.value,
                        label: item.label,
                        color: item.color
                      })),
                      highlightScope: { faded: "global", highlighted: "item" },
                      faded: { innerRadius: 30, additionalRadius: -10 }
                    }
                  ]}
                  width={400}
                  height={200}
                  slotProps={{ legend: { hidden: true } }}
                  tooltip={{ trigger: "item" }}
                  desc="User Stats"
                  title="User Stats"
                  loading={false}
                />
              </div>
              <div style={{ marginTop: 20 }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left"
                        }}
                      >
                        Color
                      </th>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left"
                        }}
                      >
                        Label
                      </th>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left"
                        }}
                      >
                        Call Counts
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {analyticsData.counts[0].data.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          <div
                            style={{
                              width: 20,
                              height: 20,
                              backgroundColor: item.color
                            }}
                          ></div>
                        </td>
                        <td
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {item.label}
                        </td>
                        <td
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-12 card rounded py-4">
            <h3>Call Logs Stats</h3>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div>
                <PieChart
                  series={[
                    {
                      data: pieData.map(item => ({
                        id: item.id,
                        value: item.value,
                        label: item.label,
                        color: item.color
                      })),
                      highlightScope: { faded: "global", highlighted: "item" },
                      faded: { innerRadius: 30, additionalRadius: -10 }
                    }
                  ]}
                  width={500}
                  height={250}
                  slotProps={{ legend: { hidden: true } }}
                  tooltip={{ trigger: "item" }}
                />
              </div>
              <div style={{ marginTop: 20 }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left"
                        }}
                      >
                        Color
                      </th>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left"
                        }}
                      >
                        Label
                      </th>
                      <th
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "left"
                        }}
                      >
                        Call Counts
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {pieData.map((item, index) => (
                      <tr key={index}>
                        <td
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          <div
                            style={{
                              width: 20,
                              height: 20,
                              backgroundColor: barColors[index]
                            }}
                          ></div>
                        </td>
                        <td
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {item.label}
                        </td>
                        <td
                          style={{ border: "1px solid #ddd", padding: "8px" }}
                        >
                          {item.value}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        {isLoading && <Loader />}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  ...state.themeChanger,
  token: state.auth.accessToken,
  user: state.auth.user
});

export default compose(
  withRouter,
  connect(mapStateToProps, { success, error })
)(MerchantDashboard);
